import CloseModal from 'actions/modal/close_modal';
import { ModerationAction } from 'models/conversation_message';
import ShowToast from 'actions/toast_deprecated/show_toast';
import { ToastType } from 'models/toast_deprecated';

export default function moderateFacebookComment(ctx, { commentId, action }) {
  const message = ACTION_MESSAGES[action];
  ctx.gateways.facebookCommentsModeration
    .add({ commentId }, { action })
    .then(response => {
      ctx.executeAction(CloseModal);
      ctx.executeAction(ShowToast, {
        type: ToastType.SUCCESS,
        message: message.success,
      });
    })
    .catch(err => {
      ctx.executeAction(CloseModal);
      ctx.executeAction(ShowToast, {
        type: ToastType.ERROR,
        message: message.error,
      });
    });
}

const ACTION_MESSAGES = {
  [ModerationAction.delete]: { success: 'The comment has been deleted', error: 'The comment could not be deleted' },
  [ModerationAction.hide]: { success: 'The comment has been hidden', error: 'The comment could not be hidden' },
};
